import { ref, readonly } from 'vue';
import { StatusBar } from './types';

const statusBar = ref<StatusBar>({
  rfidPower: null,
  batteryLevel: '~',
  serverStatus: {
    currentStatus: 'error',
    initialStatus: 'error',
  },
  eventsStatus: {
    currentStatus: 'error',
    initialStatus: 'error',
  },
  rfidStatus: {
    currentStatus: 'error',
    initialStatus: 'error',
  },
  barcodeStatus: {
    currentStatus: 'error',
    initialStatus: 'error',
  },
});

export function useStatusBar() {
  const setCurrentStatus = (
    key: keyof Omit<StatusBar, 'batteryLevel' | 'rfidPower'>,
    status: StatusBar[typeof key]['currentStatus']
  ) => {
    clearTimeout(statusBar.value[key].timerId);

    statusBar.value[key].currentStatus = status;

    statusBar.value[key].timerId = setTimeout(() => {
      statusBar.value[key].currentStatus = statusBar.value[key].initialStatus;
    }, 300);
  }

  const setInitialStatus = (
    key: keyof Omit<StatusBar, 'batteryLevel' | 'rfidPower'>,
    status: StatusBar['rfidStatus']['initialStatus']
  ) => {
    statusBar.value[key].initialStatus = status;
    statusBar.value[key].currentStatus = status;
  }

  const initRfidStatus = (status: StatusBar['rfidStatus']['initialStatus']) => {
    setInitialStatus('rfidStatus', status);
  }

  const initBarcodeStatus = (status: StatusBar['barcodeStatus']['initialStatus']) => {
    setInitialStatus('barcodeStatus', status);
  }

  const initServerStatus = (status: StatusBar['serverStatus']['initialStatus']) => {
    setInitialStatus('serverStatus', status);
  }

  const initEventsStatus = (status: StatusBar['eventsStatus']['initialStatus']) => {
    setInitialStatus('eventsStatus', status);
  }

  const setRfidStatus = (status: StatusBar['rfidStatus']['currentStatus']) => {
    setCurrentStatus('rfidStatus', status);
  }

  const setBarcodeStatus = (status: StatusBar['barcodeStatus']['currentStatus']) => {
    setCurrentStatus('barcodeStatus', status);
  } 

  const setServerStatus = (status: StatusBar['serverStatus']['currentStatus']) => {
    setCurrentStatus('serverStatus', status);
  }

  const setEventsStatus = (status: StatusBar['eventsStatus']['currentStatus']) => {
    setCurrentStatus('eventsStatus', status);
  }

  const setBatteryLevel = (level: StatusBar['batteryLevel']) => {
    statusBar.value.batteryLevel = level;
  }

  const setRfidPower = (power: StatusBar['rfidPower']) => {
    statusBar.value.rfidPower = power;
  }

  return {
    statusBar: readonly(statusBar),
    initRfidStatus,
    initBarcodeStatus,
    initServerStatus,
    initEventsStatus,
    setRfidStatus,
    setBarcodeStatus,
    setServerStatus,
    setEventsStatus,
    setBatteryLevel,
    setRfidPower,
  };
}